import { Utils, calculateInstallmentAmount, calculateNominalInterestRate } from './shared/loanUtils';
import { NumberFieldWithRange } from './shared/numberFieldWithRange';
import { CalculatorHooks, CalculatorParams } from './types';

class MortgageCalculatorEffectiveRate {
    private root: HTMLElement;

    private fields: Map<string, NumberFieldWithRange> = new Map();

    constructor(private hooks: CalculatorHooks) {
        this.root = document.getElementById(hooks.main_holder) as HTMLElement;
        if (!this.root) return;

        this.initFields();
        this.calculate();

        (window as any).addEventListener('pageshow', () => {
            this.calculate();
        });
    }

    private initFields(): void {
        ['LoanAmountGen', 'LoanTermGen', 'EffRateGen'].forEach((key) => {
            const field = new NumberFieldWithRange(this.root, key, () => this.calculate());
            this.fields.set(key, field);
        });
    }

    private calculate(): void {
        const loanAmt = this.fields.get('LoanAmountGen')!.getRawValue();
        const term = this.fields.get('LoanTermGen')!.getRawValue();
        const effRate = this.fields.get('EffRateGen')!.getRawValue();

        const allValid = Array.from(this.fields.values()).every((f) => f.validate());
        Utils.toggleAriaLive(this.root, !allValid);

        const params: CalculatorParams = {
            LoanAmount: loanAmt,
            LoanTerm: term,
        };

        const bankChooserButton = this.root.querySelector(`.${this.hooks.result.button_for_params}`);
        bankChooserButton?.setAttribute('data-params', JSON.stringify(params));

        if (!allValid) {
            Utils.setInnerText(this.root, this.hooks.result.monthly_cost, '—');
            return;
        }

        const nomRateFromEffRate = calculateNominalInterestRate(effRate);
        const monthlyCost = calculateInstallmentAmount(loanAmt, nomRateFromEffRate, term);
        Utils.setInnerText(this.root, this.hooks.result.monthly_cost, Utils.formatCurrency(Math.round(monthlyCost)));
    }
}

export default function initializeMortgageCalculatorEffectiveRate(hooks: CalculatorHooks) {
    return new MortgageCalculatorEffectiveRate(hooks);
}
